const EmptyBox = () => {
    return (
        <img
            src="/assest/Images/emptyIcon.svg"
            className="logo-png mt-3"
            style={{ width: "7%", marginBottom: "10px" }}
        />
    );
};

export default EmptyBox;